<template>
  <div class="pb-10 px-4">
    <TitleLogo title="트래블러 랭킹" />
    <v-divider></v-divider>
    
    <!-- 검색 영역 -->
    <v-sheet class="px-4 pt-4 pb-0 mb-0">
      <v-row>
        <v-col cols="12" md="3">
          <v-select
            v-model="searchField"
            :items="searchFields"
            item-text="text"
            item-value="value"
            label="검색 필드"
            outlined
            dense
            class="search-field"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchKeyword"
            :label="`${searchFields.find(f => f.value === searchField)?.text}로 검색`"
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-magnify"
            @input="handleSearch"
            @click:clear="clearSearch"
            class="search-field"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-start justify-start">
          <v-btn @click="clearSearch" color="primary" outlined class="mr-2">
            전체
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>

    <v-sheet v-if="isLoading" class="text-center mt-10">
      <div class="font-weight-medium text-body-1 pb-4">Loading...</div>
      <v-progress-circular size="48" :width="2" color="primary" indeterminate></v-progress-circular>
    </v-sheet>
    <v-sheet v-else>
      <v-list>
        <v-list-item-content>
          <v-row> <v-col cols="2">순위</v-col> <v-col>닉네임</v-col><v-col>실적</v-col><v-col>조회수</v-col> </v-row>
        </v-list-item-content>
        <v-list-item v-for="(traveler, index) in filteredItems" :key="traveler.code">
          <v-list-item-content>
            <v-row>
              <v-col cols="2">{{ traveler.originalRank }}</v-col> <v-col>{{ traveler.name }}</v-col
              ><v-col>{{ $toComma(traveler.total_amount) }}</v-col>
              <v-col>{{ traveler.pageViews || 0 }}</v-col>
              <!-- <v-col>{{ dayjs(traveler.startAt).format("YYYY.MM.DD") }}</v-col> -->
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-sheet>
  </div>
</template>
<script>
import TitleLogo from "@/views/components/TitleLogo"
import { mapState } from "vuex"
const kMaxLength = 256
export default {
  components: {
    TitleLogo,
  },
  data: () => ({
    isLoading: false,
    allItems: [], // 전체 트래블러 목록
    filteredItems: [], // 필터링된 트래블러 목록
    searchKeyword: "",
    searchField: "name", // 검색 필드 선택
    searchFields: [
      { text: "닉네임", value: "name" },
      { text: "코드", value: "code" },
      { text: "이메일", value: "email" },
      { text: "전화번호", value: "phone" },
    ],
    searchTimeout: null,
  }),
  computed: {
    ...mapState(["lafia_user"]),
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.isLoading = true
      try {
        const promotionsRes = await this.$http.get("/api/promotion/select/travelers")
        const statsRes = await this.$http.get("/api/stats/getTravelerCodeSaleStats", {
          params: {
            from: "2025-06-01",
            to: this.dayjs().format("YYYY-MM-DD"),
          },
        })

        const analyticsRes = await this.$http.get("/api/analytics")

        let items = promotionsRes.data.map((promotion) => {
          const statsItem = statsRes.data.find((e) => e.packageCode === promotion.code)
          const pageViews = this.getPageViewCount(promotion.code, analyticsRes.data.rows)
          return statsItem
            ? {
                ...statsItem,
                code: promotion.code, // code 필드 추가
                startAt: promotion.startAt,
                name: promotion.name,
                pageViews,
              }
            : {
                total_amount: 0,
                code: promotion.code, // code 필드 추가
                startAt: promotion.startAt,
                name: promotion.name,
                pageViews,
              }
        })

        items = items.filter((e) => e)
        items = items.sort((a, b) => b.total_amount - a.total_amount)
        
        // 원본 순위 저장
        items = items.map((item, index) => ({
          ...item,
          originalRank: index + 1
        }))
        
        console.log(items)
        this.allItems = items
        this.filteredItems = items
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    async handleSearch() {
      // 디바운스 적용
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      
      this.searchTimeout = setTimeout(async () => {
        if (!this.searchKeyword || this.searchKeyword.trim() === '') {
          this.filteredItems = this.allItems
          return
        }
        
        try {
          // 검색 필드에 따라 파라미터 설정
          let searchParams = {}
          
          // 선택된 필드만 검색
          searchParams[this.searchField] = this.searchKeyword
          
          // 검색 API 호출
          const searchRes = await this.$http.get("/api/promotion/select/travelers/search", {
            params: searchParams
          })
          
          const searchedCodes = searchRes.data.map(traveler => traveler.code)
          
          console.log('검색된 코드들:', searchedCodes)
          console.log('전체 아이템들:', this.allItems.map(item => ({ code: item.code, packageCode: item.packageCode, name: item.name })))
          
          // 검색된 코드와 일치하는 항목들만 필터링 (원래 순위 유지)
          this.filteredItems = this.allItems.filter(item => 
            searchedCodes.includes(item.code)
          )
          
          console.log('필터링된 결과:', this.filteredItems.length)
          
        } catch (e) {
          console.error('검색 중 오류 발생:', e)
          this.filteredItems = this.allItems
        }
      }, 300) // 300ms 디바운스
    },

    clearSearch() {
      this.searchKeyword = ""
      this.filteredItems = this.allItems
    },

    getPageViewCount(event, rows) {
      const filtered = rows.filter((row) => {
        const url = row.dimensionValues[0].value
        return url.startsWith("/reservation/buy") && url.includes(`traveler=${event}`)
      })
      const sum = filtered.reduce((acc, row) => {
        return acc + Number(row.metricValues[0].value)
      }, 0)
      return sum
    },
  },
}
</script>
<style scoped>
.col {
  font-size: 12px;
}

.search-field >>> .v-input__control .v-input__slot {
  font-size: 12px !important;
}

.search-field >>> .v-text-field__slot input {
  font-size: 12px !important;
}

.search-field >>> .v-select__slot .v-select__selection {
  font-size: 12px !important;
}

.search-field >>> .v-label {
  font-size: 12px !important;
}

.search-field >>> .v-input__append-inner .v-icon {
  font-size: 16px !important;
}
</style>
